import uniq from 'lodash.uniq';

export default function getUniqUrl(href) {
  const [path, search] = href.split('?');
  return `${path}?${uniq(search.split('&')).join('&')}`;
}
